export default function (dateValue) {
  let value = dateValue;
  if (value) {
    const date = new Date(value);
    //'mm/dd/yy'
    value = `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
  }
  return value;
}
